<script>
import Layout from "../../layouts/main";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { requestsMethods, parametersMethods } from "@/state/helpers";
import PortalNotas from "../../../components/notes/portal-notas";
import DropFile from "../../../components/drop-file/drop-file";

export default {
  components: {
    "drop-file": DropFile,
    PortalNotas,
    Layout,
  },
  data() {
    return {
      selected: null,
      options: [
        { value: "A", text: "Option A (from options prop)" },
        { value: "B", text: "Option B (from options prop)" },
      ],
      editor: ClassicEditor,
      editorData: "<p>Content of the editor.</p>",
      editorConfig: {
        // The configuration of the editor.
      },
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" },
      },
      fields: [
        { key: "nombre", label: "Nombre" },
        { key: "etiqueta", label: "Etiqueta" },
      ],
      items: [],
      productos: [],
      motivos: [],
      subMotivos: [],
      producto: "",
      motivo: "",
      subMotivo: "",
      solicitud: {},
    };
  },
  beforeMount() {
    this.getSolisitud();
  },
  methods: {
    ...requestsMethods,
    ...parametersMethods,
    getSolisitud() {
      this.getOneRequest({ id: this.$route.query.id })
        .then((solicitudes) => {
          if(!solicitudes){
            this.$bvToast.toast(
              this.$t("error.obtener-caso.content").toString(), {
              title: this.$t("error.obtener-caso.title").toString(),
              variant: "danger",
              solid: true,
            });
          }
          this.solicitud = solicitudes[0];
          Promise.all([
            this.getProductos(),
            this.getMotivos({ idproducto: this.solicitud.idproducto }),
            this.getSubMotivos({
              idproducto: this.solicitud.idproducto,
              idtipo: this.solicitud.idtipo,
            }),
          ])
            .then(([productos, motivos, subMotivos]) => {
              if(!productos || !motivos || !subMotivos){
                this.$bvToast.toast(
                  this.$t("error.obtener-detalle-caso.content").toString(), {
                  title: this.$t("error.obtener-detalle-caso.title").toString(),
                  variant: "danger",
                  solid: true,
                });
              }
              this.productos = productos;
              this.motivos = motivos;
              this.subMotivos = subMotivos;
              this.producto = this.solicitud.idproducto;
              this.motivo = this.solicitud.idtipo;
              this.subMotivo = this.solicitud.idsubtipo;
            })
        })
    },
  },
};
</script>
<template>
  <Layout>
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">
          N° {{ solicitud.refnum }} : {{ solicitud.asunto }}
        </h4>
        <hr />
        <div class="row">
          <div class="col-md-4 col-sm-12">
            <b-form-group
              id="input-group-1"
              label="*Producto"
              label-for="formrow-inputState"
            >
              <b-form-select
                id="formrow-inputState"
                v-model="producto"
                :options="productos"
                value-field="id"
                text-field="nombre"
                type="text"
                disabled
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-12">
            <b-form-group
              id="input-group-1"
              label="*Motivo"
              label-for="formrow-inputState"
            >
              <b-form-select
                id="formrow-inputState"
                v-model="motivo"
                :options="motivos"
                value-field="id"
                text-field="nombre"
                type="text"
                disabled
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-12">
            <b-form-group
              id="input-group-1"
              label="*Submotivo"
              label-for="formrow-inputState"
            >
              <b-form-select
                id="formrow-inputState"
                v-model="subMotivo"
                :options="subMotivos"
                value-field="id"
                text-field="nombres"
                type="text"
                disabled
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="col-md-5 col-sm-12">
            <b-form-group label="*Asunto" label-for="formrow-inputCity">
              <b-form-input
                v-model="solicitud.asunto"
                id="formrow-inputCity"
                type="text"
                disabled
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-5 col-sm-12">
            <b-form-group
              id="input-group-1"
              label="Cuenta"
              label-for="formrow-inputState"
            >
              <b-form-input
                v-model="solicitud.idcuentadesc"
                id="formrow-inputCuenta"
                type="text"
                disabled
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-sm-12">
            <b-tabs content-class="mt-3">
              <b-tab active>
                <template #title>
                  <i :class="`bx  bxs-edit`"></i>
                  <span>Notas</span>
                </template>
                <PortalNotas
                  tipoObjeto="casos"
                  :idObjeto="parseInt($route.query.id)"
                />
              </b-tab>
              <b-tab title="Second">
                <template #title>
                  <i :class="`bx  bx-paperclip`"></i>
                  <span>Archivos</span>
                </template>

                <drop-file
                  tipoObjeto="casos"
                  :idObjeto="parseInt($route.query.id)"
                />
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
